(function () {
  'use strict';

  const systems = [
        {key: 'METRIC', label: 'core-permissoes.organizacao.usuarios.popup.measurementSystemMetric'},
        {key: 'IMPERIAL', label: 'core-permissoes.organizacao.usuarios.popup.measurementSystemImperial'}
      ],
      functions = {
        getSystemByKey: (key) => systems.find(system => system.key === key),
        getAllSystems: () => systems,
        getDefaultKeyForLanguage: (languageKey) => languageKey === 'EN_US' ? 'IMPERIAL' : 'METRIC'
      };

  angular
    .module('enumModule')
    .constant('MeasurementSystemEnum', Object.assign({}, systems, functions));
}());
